import { render, staticRenderFns } from "./EnvVarsWrapperBlock.vue?vue&type=template&id=5539f14d&scoped=true&"
import script from "./EnvVarsWrapperBlock.vue?vue&type=script&lang=js&"
export * from "./EnvVarsWrapperBlock.vue?vue&type=script&lang=js&"
import style0 from "./EnvVarsWrapperBlock.vue?vue&type=style&index=0&id=5539f14d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539f14d",
  null
  
)

export default component.exports